'use client';
import { HeroBlock } from '@/payload-types';
import { Media } from '@onclicks/sharedcomponents/Media/Media';
import LocalityContactButton from './LocalityContactButton';
import { useLocalityService } from '@/providers/Locality';
import RichText from './LocalityRichText';

const LocalityBanner: React.FC<HeroBlock> = (data) => {
  const { links, media, subtitle, title, richText } = data;

  const localityService = useLocalityService();

  return (
    <div className="bg-white lg:h-120">
      <div className="relative">
        <div className="mx-auto my-auto max-w-7xl">
          <div className="relative z-10 h-full lg:w-full lg:max-w-2xl">
            <svg
              viewBox="0 0 100 100"
              preserveAspectRatio="none"
              aria-hidden="true"
              className="absolute inset-y-0 right-8 hidden h-full translate-x-1/2 transform fill-white lg:block"
            >
              <polygon points="0,0 90,0 50,100 0,100" />
            </svg>
            <div className="lg:py-auto relative px-6 xsmall:py-20 lg:px-8 lg:pr-0">
              <div className="mx-auto max-w-2xl lg:mx-0 lg:max-w-xl pt-12">
                {title && (
                  <h1 className="font-bold tracking-tight text-gray-900 xsmall:text-4xl lg:text-5xl">
                    {localityService?.replaceTags(title)}
                  </h1>
                )}
                {subtitle && (
                  <h2 className="mt-5 text-gray-600">
                    {localityService?.replaceTags(subtitle)}
                  </h2>
                )}
                {richText && <RichText data={richText} className="mt-5" />}
                {links && (
                  <LocalityContactButton className="mt-5" links={links} />
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="h-full lg:max-h-120 bg-gray-50 xsmall:relative lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2">
          <Media
            resource={media}
            className="aspect-[3/2] object-cover lg:aspect-auto lg:h-full lg:w-full"
            size="(min-width: 64rem) 50vw, 100vw"
            priority
          />
          {/* <Image
                        alt={data.image.alt}
                        title={data.image.title}
                        src={data.image.source}
                        className="aspect-[3/2] object-cover lg:aspect-auto lg:h-full lg:w-full"
                    /> */}
        </div>
      </div>
    </div>
  );
};

export { LocalityBanner };
